import { type JSX, useState } from "react";

import { useGKEAdoption } from "../../hooks/cloudAnalytics/useGKEAdoption";
import useGKECostAllocation from "../../hooks/cloudAnalytics/useGKECostAllocation";
import useUpdateEffect from "../../hooks/useUpdateEffect";
import { useIsEntitledToCurrentDashboardType } from "../hooks/useIsEntitledByDashboardType";
import { Loader } from "../Loader";
import { GKELensEnticement } from "./GKELensEnticement";

type GKELensGuardProps = {
  children: JSX.Element;
};

const GKELensGuard = ({ children }: GKELensGuardProps) => {
  const [gkeCostAllocation] = useGKECostAllocation();
  const [gkeAdoption] = useGKEAdoption();
  const [showEmptyState, setShowEmptyState] = useState(true);
  const isEntitled = useIsEntitledToCurrentDashboardType();

  useUpdateEffect(() => {
    if (gkeCostAllocation?.enabled || gkeAdoption?.completedSuccesfully) {
      setShowEmptyState(false);
    }
  }, [gkeAdoption, gkeCostAllocation]);

  if (gkeCostAllocation === undefined || gkeAdoption === undefined) {
    return <Loader />;
  }

  if (showEmptyState || !isEntitled) {
    return <GKELensEnticement state={isEntitled ? "activate" : "upgrade"} />;
  }

  return children;
};

export default GKELensGuard;
